import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { t } from "@/i18n";

export const PopularItem = ({ title, icon: Icon, items, accentColor = "#FF2A6D", lang = "da" }) => {
  if (!items || items.length === 0) return null;

  const maxCount = items[0]?.count || 1;

  return (
    <Card
      className="bg-card border-border shadow-none animate-fade-in-up opacity-0 stagger-4"
      data-testid={`popular-${title.toLowerCase().replace(/\s/g, "-")}`}
    >
      <CardHeader className="pb-4">
        <div className="flex items-center gap-2">
          {Icon && <Icon className="w-4 h-4" style={{ color: accentColor }} />}
          <CardTitle className="text-sm font-bold tracking-tight">{title}</CardTitle>
        </div>
        <p className="text-[13px] text-muted-foreground mt-1">{t(lang, "currentMonth")}</p>
      </CardHeader>
      <CardContent className="space-y-3">
        {items.map((item, i) => {
          const pct = (item.count / maxCount) * 100;
          return (
            <div key={item.name} data-testid={`popular-item-${i}`}>
              <div className="flex items-center justify-between mb-1.5">
                <div className="flex items-center gap-2">
                  {i === 0 && (
                    <div
                      className="w-1.5 h-1.5 rounded-full"
                      style={{ backgroundColor: accentColor }}
                    />
                  )}
                  <span className={`text-sm ${i === 0 ? "text-foreground font-semibold" : "text-muted-foreground"}`}>
                    {item.name}
                  </span>
                </div>
                <span className={`text-sm font-kpi ${i === 0 ? "text-foreground" : "text-muted-foreground"}`}>
                  {item.count}
                </span>
              </div>
              <div className="w-full h-1 bg-secondary rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-700"
                  style={{
                    width: `${pct}%`,
                    backgroundColor: accentColor,
                    opacity: i === 0 ? 0.8 : 0.3,
                  }}
                />
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};
